<div class="row">
    <div class="col-xs-12">
        <div class="main-box clearfix" style="min-height: 200px;">
            <header class="main-box-header clearfix col-xs-offset-1 col-xs-10 text-center" *ngIf="step5Error?.hasErrorFlag">
                <h2 class="has-error">
                    <span class="help-block">
                        <em>*</em>{{step5Error.errorMessage}}
                    </span>
                </h2>
            </header>
            <div class="row" style="opacity: 0.6 !important">
                <div class="col-xs-3 col-xs-offset-1">
                    <h3 style="border-bottom: none;">Current Job Match Score</h3>
                </div>
                <div class="col-xs-4">
                    <div>
                        <div>
                            <span style="margin-left: {{intelligencePreferences?.value}}%">
                                <strong>{{intelligencePreferences?.value}}&nbsp;</strong>
                                <span *ngIf="intelligencePreferences?.company" [title]="intelligencePreferences?.company">[{{intelligencePreferences?.company}}]</span>
                            </span>
                        </div>
                        <div>
                            <span style="font-size: 20px;margin-top: -24px; margin-left: {{intelligencePreferences?.value}}%" class="fa fa-caret-down"></span>
                        </div>
                    </div>
                    <div class="slider-current-4dot5-score slde3 markerSliderGap" disabled="true">
                        <label class="pull-left" style="padding-top: 12px;font-size:inherit;">0</label>
                        <label class="pull-right" style="padding-top: 12px; margin-right: -5px;font-size:inherit;">100</label>
                    </div>
                    <span class="slider-label text-center"></span>
                </div>
            </div>
            <div class="row" style="margin-top: 30px; margin-bottom: 50px;">
                <div class="col-xs-offset-2 col-xs-2">
                    <span>Active Candidates :</span>
                    <span class="pull-right">
                        <span>{{currentScoreCandidateCounts?.activeCandidatesCount}}</span>
                    </span>
                </div>
                <div class="col-xs-offset-1 col-xs-2">
                    <span>Passive Candidates :</span>
                    <span class="pull-right">
                        <span>{{currentScoreCandidateCounts?.passiveCandidatesCount}}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-3 col-xs-offset-1">
                    <h3 style="border-bottom: none;">Adjust Job Match Score</h3>
                </div>
                <div class="col-xs-4">
                    <div>
                        <div>
                            <span style="margin-left: {{intelligencePreferences?.value}}%">
                                <strong>{{intelligencePreferences?.value}}&nbsp;</strong>
                                <span *ngIf="intelligencePreferences?.company" [title]="intelligencePreferences?.company">[{{intelligencePreferences?.company}}]</span>
                            </span>
                        </div>
                        <div>
                            <span style="font-size: 20px;margin-top: -24px; margin-left: {{intelligencePreferences?.value}}%" class="fa fa-caret-down"></span>
                        </div>
                    </div>

                    <div class="slider-adjust-4dot5-score slde3 markerSliderGap">
                        <label class="pull-left" style="padding-top: 12px;font-size:inherit;">0</label>
                        <label class="pull-right" style="padding-top: 12px; margin-right: -5px;font-size:inherit;">100</label>
                    </div>
                    <span class="slider-label text-center" id="adjust4dot5ScoreDisplayValue"></span>
                </div>
            </div>
            <div class="row" style="margin-top: 30px; margin-bottom: 30px;">
                <div class="col-xs-offset-2 col-xs-2">
                    <span>Active Candidates :</span>
                    <span class="pull-right">
                        <span *ngIf="!loadingAdjustedCandidatesCountFlag">{{adjustedScoreCandidateCounts?.activeCandidatesCount}}</span>
                        <span *ngIf="loadingAdjustedCandidatesCountFlag" class="skeleton-container d-inline-block" style="width: 30px;">
                            <span class="skeleton-paragraph width-100 skeleton-loading my-0 d-inline-block"></span>
                        </span>
                    </span>
                </div>
                <div class="col-xs-offset-1 col-xs-2">
                    <span>Passive Candidates :</span>
                    <span class="pull-right">
                        <span *ngIf="!loadingAdjustedCandidatesCountFlag">{{adjustedScoreCandidateCounts?.passiveCandidatesCount}}</span>
                        <span *ngIf="loadingAdjustedCandidatesCountFlag" class="skeleton-container d-inline-block" style="width: 30px;">
                            <span class="skeleton-paragraph width-100 skeleton-loading my-0 d-inline-block"></span>
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xs-12 mb-3" *ngIf="isOutreachEnabled">
        <app-send-candidate-outreach-email outreachEmailId="createOrEditRequisition" [sendOutreachEmail]="sendOutreachEmail"
            (sendOutreachEmailUpdated)="onSendOutreachEmailUpdated($event)"></app-send-candidate-outreach-email>
    </div>
</div>
